export default "__VITE_ASSET__ClHP3s_q__"